module.exports = __webpack_public_path__ + "img/signup-btn.a7cbbb6b.webp";